import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import History from './History'
import Config from './Config'
import ConfigForm from './ConfigForm'
import ErrorFallBack from '@/layout/Error'

const Notifications: React.FC<unknown> = () => {
  return (
    <Routes>
      <Route
        path="history"
        errorElement={<ErrorFallBack />}
        element={<History />}
      />
      <Route
        path="config"
        errorElement={<ErrorFallBack />}
        element={<Config />}
      />
      <Route
        path="config/createConfig"
        errorElement={<ErrorFallBack />}
        element={<ConfigForm />}
      />
      <Route
        path="config/:configId"
        errorElement={<ErrorFallBack />}
        element={<ConfigForm />}
      />
      <Route path="*" element={<Navigate to="history" />} />
    </Routes>
  )
}

export default Notifications
